import LayoutPadrao from 'lg-vue-components/layoutPadrao'
export default {
  path: '/',
  redirect: 'consolidacao-folha',
  component: LayoutPadrao,
  children: [
    {
      path: '/consolidacao-folha',
      name: 'consolidacao-folha',
      component: () => import('./pages/ListarConsolidacaoFolha')
    }
  ]
}
